import { ModalConfig } from '@/models/ModalConfig';

export enum CommonTypes {
    SET_FLOATING_COURSE_ACTIONS_CONFIGURATION = '@common/SET_FLOATING_COURSE_ACTIONS_CONFIGURATION',
    OPEN_MODAL = '@common/OPEN_MODAL',
    CLOSE_MODAL = '@common/CLOSE_MODAL',
    CLEAR_MODAL = '@common/CLEAR_MODAL',
}

export interface CommonState {
    data: Common;
    modal: Record<string, ModalConfig>;
}

export interface FloatingCourseActionsBarConfiguration {
    previousButtonTitle: string;
    nextButtonTitle: string;
    saveButtonTitle: string;
    currentStep: number;
    totalSteps: number;
    onSave: CallableFunction;
    saveDisabled: boolean;
    onPrevious: CallableFunction;
    onNext: CallableFunction;
    previewDisabled: boolean;
    nextDisabled: boolean;
    blockUi: boolean;
}

export interface Common {
    floatingCourseActionsBarConfiguration: FloatingCourseActionsBarConfiguration;
}
